import React from 'react';
import styled from 'styled-components';

import ButtonWrapper from '../Form/ButtonWrapper';
import Button from '../../collections/Button/Button';

import FaExclamationTriangle from 'react-icons/lib/fa/exclamation-triangle';
import { media } from '../../utilities/style-utilities';
import { emy, fontEdenredLight, fontUbuntuLight } from '../../utilities/utilities';

const SizedExclamation = styled(FaExclamationTriangle)`
  font-size: 1.5rem;
  color: #ffffff;
`;

const DialogBackground = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 100;
  background-color: rgba(0, 51, 149, 0.8);
  display: ${props => props.visibile ? 'flex' : 'none'};
  justify-content: center;
  align-items: center;
`

const DialogBox = styled.div`
  max-width: 500px;
  width: 100%;
  padding: 1rem;
  background-color: #e6e6e6;
  margin-top: 4rem;
  align-self: flex-start;
  flex: 1 1 auto;
`

const ErrorBox = styled.div`
  display: ${props => props.visibile === true ? 'flex' : 'none' };
  /* color: #0d1b58; */
  background-color: #f0dddd;
  color: #a84343;
  border: 1px solid #d12f2c;
  align-self: center;
  padding: 0.5rem;
  width: 100%;
`;

const ErrorMessage = styled.span`
  display: inline-flex;
  font-family: ${props => props.fontFamily ? props.fontFamily : fontEdenredLight};
  font-size: ${emy(17)};
  flex: 1 1 auto;
  align-self: center;
  justify-content: center;
  /* color: ${props => props.textColor ? props.textColor : '#0d1b58'}; */
`;

const ErrorIcon = styled.span`
  display: inline-flex;
  border: 2px solid #ffffff;
  border-radius: 50%;
  justify-content: center;
  padding: 0.4rem;  
  margin-right: 0.5rem;
  align-items: center;
  background-color: #d12f2c;
  align-self: baseline;
  flex: 0 0 auto;
`

const DialogButtonWrapper = styled(ButtonWrapper)`
  margin-bottom: 0;
  justify-content: space-between;
  /* ${ media.desktop`
    flex-direction: row;
  `} */
  flex-direction: column;
`
const DialogButton = styled(Button)`
  margin: 0;
  /* width: 150px; */
`

const WordGap = styled.span`
  display: inline-flex;
  margin: 0.75rem 0;
  width: 100%;
  justify-content: center;
  font-size: ${emy(28)};
  font-family: ${props => props.fontFamily ? props.fontFamily : fontUbuntuLight};
  color: ${props => props.textColor ? props.textColor : '#0D1B58'};
`;

const Modal = (props) => {

  return (
    <DialogBackground visibile={props.visibile}>
      <DialogBox>
        <ErrorBox visibile={props.visibile}>
          <ErrorIcon>
            <SizedExclamation />
          </ErrorIcon>
          <ErrorMessage>{props.message}</ErrorMessage>
      
        </ErrorBox>

        <DialogButtonWrapper>
          <DialogButton 
            color={props.ui.cardActivation.buttons.forward.textColor} 
            background={props.ui.cardActivation.buttons.forward.backgroundColor}
            border={props.ui.cardActivation.buttons.forward.borderColor} 
            type="button"
            role="button"
            onClick={props.onActivate}>
              {'Do you want to activate another card?'}
          </DialogButton>
          <WordGap textColor={props.ui.cardActivation.card.titleTextColor}>or</WordGap>
          <DialogButton 
            color={props.ui.cardActivation.buttons.backward.textColor} 
            background={props.ui.cardActivation.buttons.backward.backgroundColor}
            border={props.ui.cardActivation.buttons.backward.borderColor} 
            onClick={props.onRetrieve}
            type="button" 
            role="button">
              {'Retrieve your card PIN?'}
          </DialogButton>
        </DialogButtonWrapper>
        
      </DialogBox>
    </DialogBackground>
  )
}

export default Modal;


// WEBPACK FOOTER //
// ./src/components/Modal/Modal.js